import { createContext, ReactNode, useContext, useState } from "react";
import { NotificationModel } from "../../NotificationModel";
import { MyNotification } from "../../Modules/shared/components/MyNotification";

interface contextValue {
    addNotification: (n: NotificationModel) => void;
}
export const NotificationContext = createContext<contextValue | undefined>(undefined)

interface providerProps {
    children: ReactNode;
}

export const NotificationProvider: React.FC<providerProps> = ({ children }) => {
    const [notification, setNotification] = useState<NotificationModel>()
    const addNotification = (notification: NotificationModel) => {
        setNotification(notification)
    }
    return (
        <NotificationContext.Provider value={{ addNotification }}>
            {children}
            {notification && <MyNotification notification={notification} />}
        </NotificationContext.Provider>
    )
}

export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (context === undefined) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context.addNotification;
};
